(function () {
  'use strict'

  /**
   * @ngdoc module
   * @name FormlyHtmlCheckboxInput
   * @module thismoment.common.formly.inputs.html-checkbox
   *
   * @description
   * A checkbox that allows the user to pass HTML to the label
   */

  var MODULE_NAME = 'thismoment.common.formly.inputs.html-checkbox'
  var templateUrl = require('./tpl/html-checkbox.html')

  require('dynamic-bind-html') // ಠ_ಠ

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml',
      require('angular-formly')
    ])
    .run(requiredConfig)

  requiredConfig.$inject = ['formlyConfig']
  function requiredConfig (formlyConfig) {
    formlyConfig.setType([
      {
        name: 'html-checkbox',
        extends: 'checkbox',
        templateUrl: templateUrl
      }
    ])
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/html-checkbox.js